<!-- eslint-disable max-len -->
<style scoped>
  .project-actions-dialog-yes {
    background-color: #3F6E75;
  }
  .project-actions-dialog-no {
    background-color: #863A21;
  }
</style>
<style>
  .radio-list {
    input[type="radio"] {
        position: relative;
        height: 1rem;
    }
  }
</style>
<template>
  <div class="view-contents">
    <UnavailablePageModal
      v-if="project"
      pageName="Project Actions"
      :project="project"
      :projectId="project.id"
    />
    <div class="section-header">
      <div class="row bold-title">
        <div class="col">Project Actions</div>
      </div>
    </div>
    <div class='section-header'>
      <b-overlay :show="formLoading">
        <div class='row'>
          <div class='col'>
            <b-link v-if='isEditable' class="add-link" @click="onOpenProjectPracticeModalClick">
              <b-icon icon="plus"></b-icon>Add Practice
            </b-link>
            <b-modal id="projectPracticeModal" :title="projectPractice && projectPractice.id ? 'Edit Practice' : 'New Practice'" size="xl">
              <p>
                <b-overlay :show="!isEditable" opacity=".33">
                  <VueFormGenerator :schema="formSchema" :model="projectPractice" :options="formOptions" @validated="onValidated"/>
                  <template v-slot:overlay>
                    <div></div>
                  </template>
                </b-overlay>
              </p>
              <template v-slot:modal-footer>
                <b-button size="sm" variant="danger" @click="onProjectPracticeCancelClick" class='project-actions-dialog-no'>Cancel</b-button>
                <div v-if='isEditable'>
                  <b-button v-if="projectPractice && projectPractice.id && projectPractice.id > 0" :disabled="!formValid" size="sm" variant="success" @click="onProjectPracticeUpdateClick" class='management-plan-dialog-yes'>
                    <span>Save Practice</span>
                  </b-button>
                  <b-button v-else :disabled="!formValid" size="sm" variant="success" @click="onProjectPracticeAddClick" class='project-actions-dialog-yes'>
                    <span>Save Practice</span>
                  </b-button>
                </div>
              </template>
            </b-modal>
          </div>
        </div>
        <div class='row'>
          <div class='col'>
            <div v-if="projectPractices.length === 0">No Project Actions have been added</div>
            <b-table v-else id='practiceTable' striped :fields="projectPracticesFields" :items="getProjectPractices()">
              <template v-slot:cell(actions)="row">
                <b-link @click="onProjectPracticeEditClick(row)" class="mr-1">
                  <span v-if='isEditable'>Edit</span>
                  <span v-else>View</span>
                </b-link>
                <span v-if='isEditable'>
                  <span>|&nbsp;</span>
                    <b-link variant="danger" v-b-modal="`deleteProjectAction-${row.item.id}`">Delete </b-link>
                </span>
                <b-modal :id="`deleteProjectAction-${row.item.id}`" title="Confirm Project Action Delete" @ok="onProjectPracticeDeleteClick(row)">
                  <div>Are you sure you want to delete this Project Action?</div>
                  <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button size="sm" variant="danger" @click="cancel" class='incentive-payments-dialog-no'>No</b-button>
                    <b-button size="sm" variant="success" @click="ok" class='incentive-payments-dialog-yes'>Yes</b-button>
                  </template>
              </b-modal>
              </template>
            </b-table>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>
<script>
/* eslint-disable max-len, padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';
import UnavailablePageModal from '@/components/common/UnavailablePageModal.vue';
import ProjectApprovalMembershipManager from '@/mixins/projectApprovalMembershipManager';
import ProjectSchemaHelper from '../../mixins/projectSchemaHelper';

export default {
  name: 'ProjectActions',
  mixins: [ProjectApprovalMembershipManager, ProjectSchemaHelper],
  components: {
    UnavailablePageModal,
  },
  computed: {
    ...mapState(['config']),
    ...mapState('Project', {
      project: (state) => state.project,
      projectPractices: (state) => state.projectPractices,
      practices: (state) => state.practices,
      practiceComponents: (state) => state.practiceComponents,
      targetSeasons: (state) => state.targetSeasons,
    }),
  },
  data() {
    return {
      formLoading: false,
      formOptions: { validateAfterChanged: true },
      formSchema: {},
      formValid: false,
      practiceComponentsFiltered: [],
      projectId: null,
      projectPractice: null,
      projectPracticeModalId: 'projectPracticeModal',
      projectPracticesFields: [
        {
          key: 'practice',
          label: 'Practice',
          formatter: (value) => {
            if (value) {
              return value.name;
            }
            return '';
          },
        },
        {
          key: 'practiceComponent',
          label: 'Component',
          formatter: (value) => {
            if (value) {
              return value.name;
            }
            return '';
          },
        },
        {
          key: 'targetSeason',
          label: 'Target Season',
          formatter: (value) => {
            if (value) {
              return value.name;
            }
            return '';
          },
        },
        {
          key: 'targetYear',
          label: 'Target Year',
          formatter: (value) => value.getFullYear(),
        },
        {
          key: 'unitsFields',
          label: 'Unit(s)/Field(s)',
        },
        {
          key: 'acres',
          label: 'Acres',
        },
        {
          key: 'notes',
          label: 'Notes',
        },
        {
          key: 'actions',
          label: '',
        },
      ],
    };
  },
  mounted() {
    (async () => {
      this.projectId = parseInt(this.$route.params.id, 10);
      await this.load();
    })();
  },
  methods: {
    initProjectPractice() {
      this.practiceComponentsFiltered = [];
      return {
        projectId: this.projectId,
        practiceId: null,
        practice: null,
        practiceComponentId: null,
        practiceComponent: null,
        targetSeasonId: null,
        targetYear: null,
        unitsFields: null,
        acres: null,
        notes: null,
      };
    },
    getProjectPractices() {
      let projectPractices = this.projectPractices.map((e) => ({
        id: e.id,
        projectId: this.projectId,
        practice: this.practices.filter((x) => x.id === e.practiceId)[0],
        practiceComponent: this.practiceComponents.filter((x) => x.id === e.practiceComponentId)[0],
        targetSeason: this.targetSeasons.filter((x) => x.id === e.targetSeasonId)[0],
        targetYear: new Date(e.targetYear),
        unitsFields: e.unitsFields,
        acres: e.acres,
        notes: e.notes,
        practiceId: e.practiceId,
        practiceComponentId: e.practiceComponentId,
        targetSeasonId: e.targetSeasonId,
      }));
      projectPractices = projectPractices.sort(
        (a, b) => {
          if (a.targetSeason && b.targetSeason) {
            if ((a.targetYear.getFullYear() === b.targetYear.getFullYear()) && (a.targetSeason.sortOrder === b.targetSeason.sortOrder)) {
              if (a.unitsFields < b.unitsFields) return -1;
              if (a.unitsFields === b.unitsFields) return 0;
              return 1;
            }
            return (a.targetYear.getFullYear() - b.targetYear.getFullYear()) || (a.targetSeason.sortOrder - b.targetSeason.sortOrder);
          }
          if ((a.targetSeason && !b.targetSeason)) {
            if (a.targetYear.getFullYear() > b.targetYear.getFullYear()) {
              return 1;
            }
            return -1;
          }
          if ((!a.targetSeason && b.targetSeason)) {
            if (a.targetYear.getFullYear() < b.targetYear.getFullYear()) {
              return -1;
            }
            return 1;
          }
          if (a.targetYear.getFullYear() === b.targetYear.getFullYear()) {
            if (a.unitsFields < b.unitsFields) return -1;
            if (a.unitsFields === b.unitsFields) return 0;
            return 1;
          }
          return (a.targetYear.getFullYear() - b.targetYear.getFullYear());
        },
      );
      return projectPractices;
    },
    async load() {
      this.formLoading = true;
      await this.$store.dispatch('Project/getPractices');
      await this.$store.dispatch('Project/getPracticeComponents');
      await this.$store.dispatch('Project/getTargetSeasons');
      // await this.$store.dispatch('Project/getProject', this.projectId);
      await this.$store.dispatch('Project/getProjectPractices', this.projectId);
      this.formSchema = this.getPracticeSchema();
      this.formLoading = false;
    },
    onProjectPracticeAddClick() {
      (async () => {
        this.formLoading = true;
        this.$bvModal.hide(this.projectPracticeModalId);
        await this.$store.dispatch('Project/postProjectPractice', this.projectPractice);
        await this.$store.dispatch('Project/getProjectPractices', this.projectId);
        this.projectPractice = this.initProjectPractice();
        this.formLoading = false;
      })();
    },
    onProjectPracticeCancelClick() {
      this.$bvModal.hide(this.projectPracticeModalId);
      this.projectPractice = this.initProjectPractice();
    },
    onProjectPracticeDeleteClick(row) {
      (async () => {
        this.formLoading = true;
        await this.$store.dispatch('Project/deleteProjectPractice', row.item.id);
        await this.$store.dispatch('Project/getProjectPractices', this.projectId);
        this.projectPractice = this.initProjectPractice();
        this.formLoading = false;
      })();
    },
    onProjectPracticeEditClick(row) {
      this.projectPractice = { ...row.item };
      this.practiceComponentsFiltered = this.practiceComponents.filter((e) => e.practiceId === this.projectPractice.practiceId);
      this.validateRequiredFields();
      this.$bvModal.show(this.projectPracticeModalId);
    },
    onProjectPracticeUpdateClick() {
      (async () => {
        this.formLoading = true;
        this.$bvModal.hide(this.projectPracticeModalId);
        this.projectPractice.practice = this.projectPractices.filter((e) => e.id === this.projectPractice.practiceId)[0];
        this.projectPractice.practiceComponent = this.practiceComponents.filter((e) => e.id === this.projectPractice.practiceComponentId)[0];
        await this.$store.dispatch('Project/putProjectPractice', this.projectPractice);
        await this.$store.dispatch('Project/getProjectPractices', this.projectId);
        this.projectPractice = this.initProjectPractice();
        this.formLoading = false;
      })();
    },
    onOpenProjectPracticeModalClick() {
      this.projectPractice = this.initProjectPractice();
      this.validateRequiredFields();
      this.$bvModal.show(this.projectPracticeModalId);
    },
    onValidated(isValid, errors) {
      this.practiceComponentsFiltered = this.practiceComponents.filter((e) => e.practiceId === this.projectPractice.practiceId);
      if (this.projectPractice.practiceComponentId && !this.practiceComponentsFiltered.map((e) => e.id).includes(this.projectPractice.practiceComponentId)) {
        this.projectPractice.practiceComponentId = null;
      }
      this.formValid = isValid;
      this.validateRequiredFields(errors);
    },
    validateRequiredFields(errors) {
      this.formValid = true;
      if (!this.projectPractice.practiceId || this.projectPractice.practiceId == null) this.formValid = false;
      if (!this.projectPractice.practiceComponentId || this.projectPractice.practiceComponentId == null) this.formValid = false;
      if (!this.projectPractice.targetYear || this.projectPractice.targetYear == null) this.formValid = false;
      if (!this.projectPractice.unitsFields || this.projectPractice.unitsFields == null || this.projectPractice.unitsFields === '') this.formValid = false;
      if (!this.projectPractice.acres || this.projectPractice.acres == null) this.formValid = false;
      if (this.projectPractice.acres && this.projectPractice.acres < 0) this.formValid = false;
      if (errors && errors.length > 0) this.formValid = false;
    },
  },
};
</script>
